import { Component, ViewChild } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import { NavController, ToastController, LoadingController, AlertController, ViewController, Config, Select   } from 'ionic-angular';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { cmpFilterKaryawan } from "@src/components/presensi";
import { RepositoryMyRadiant, HelperMyRadiant,UserMyRadiant as User, PresensiProvider} from '@providers/index';

import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { TabsPage } from '../../dashboard';
import { UserPresensi } from '@providers/presensi';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { Api } from '@providers/api/api';

@Component({
  selector: 'presensi-attendance',
  templateUrl: 'page.html'
})
export class Attendance {
  loading : any;
  isLogin : any = 0;
  data = {
    attendance:[{}],
    dateMulai:"",
    dateAkhir:"",
    dateJarak:"",
    employee:"Me",
  };
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.Employee_ID,
    nik : this.userApi.data.NIK,
    user_code : this.userApi.data.NIK,
    date_start : this.today.awalYmd,
    date_end : this.today.akhirYmd,
  }
  @ViewChild('filterKaryawan') selectRef: Select;
  constructor(
    public navCtrl        : NavController,
    public toastCtrl      : ToastController,
    public loadingCtrl    : LoadingController,
    public alertCtrl      : AlertController,
    public userApi        : User,
    public menuCtrl       : MenuController,
    public modalCtrl      : ModalController,
    public nav            : Nav,
    public navParams      : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    public config         : Config,
    public sanitizer      : DomSanitizer,
    public events         : Events,
    public userPresensi   : UserPresensi,
    public presensiProvider : PresensiProvider,
    public photoViewer    : PhotoViewer,
    public api            : Api
  ) {
  	this.valDateJarak = {
  		from:this.today.obj.awal,
  		to:this.today.obj.akhir
    };
    this.data.dateJarak = this.today.awal +' s/d '+this.today.akhir;
    this.getAttendance();
    localStorage.setItem('presensi_karyawan_attendance','me');
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  filterKaryawan(){
    let me = this;
    this.showLoading();
    console.log(this.userPresensi.akses);
    let params = {
      id:this.userApi.data.Employee_ID,
      all_data:this.userPresensi.akses['edit_presentase_presensi_hak_akses_data'],
    };
    this.repositoryProvider.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {karyawan:resp.data.list,isAddHoc:resp.data.isAddHoc,fiturSearching:true,title:"My Team Profile",level:resp.data.level,all_data:params.all_data}, {cssClass: 'select-modal',enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          if(karyawan){
            if (karyawan=='me') {
              me.data.employee = "Me";
              me.parameter.nik = this.userApi.data.NIK;
              me.parameter.user_code = this.userApi.data.NIK;
              me.parameter.id = this.userApi.data.Employee_ID;
              me.parameter.flag = "team";
            }else{
              me.data.employee = karyawan.employee_name;
              me.parameter.nik = karyawan.nik;
              me.parameter.user_code = karyawan.employee_code;
              me.parameter.id = karyawan.employee_id;
              me.parameter.flag = "team";
            }
            // this.showLoading();
            me.getAttendance();
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }

  getAttendance(){
    let me = this;
    this.loading = this.helper.showLoading('Loading Data..');
    this.repositoryProvider.getListAttendance(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.attendance = resp.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  

  openCalendar() {
    let me = this;
    this.helper.valDateJarak = this.valDateJarak;
    this.helper.openCalendar((data,role) => {

      if (role=="done") {
        let date = data;
        let from: CalendarResult = date.from;
        let to: CalendarResult = date.to;	
          this.startDate = from.dateObj;
          this.parameter.date_start = from.string;
          this.parameter.date_end = to.string;
          this.data.dateJarak = this.helper.dateToString(from.dateObj) + ' s/d ' + this.helper.dateToString(to.dateObj);
          me.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          }
          this.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          };
          me.getAttendance();
          
      }
    })  
  }

  changeProductivity(data){
    this.helper.imageSelected = null;
    let me = this;
    let generated_class_button = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    let generated_class_label = Math.random().toString(36).substring(1, 15) + Math.random().toString(36).substring(1, 15);
    let akses = this.userPresensi.akses;
    console.log(akses);
    if (akses['edit_presentase_presensi'] && data.attendance !== 'FI') {
      let element_content = this.generate_element('hr',data,generated_class_label,generated_class_button);
      let options = {
        buttonConfirm : "Save",
        title         : "Detail",
        content       : element_content,
        eventListenerContent : true,
        cmpListeners : "progress-presensi",
        generated_class_btn : generated_class_button,
        generated_class_label : generated_class_label
      };
      this.helper.imageNameSelected = this.helper.ifvalnull(data.file_name,null);
      this.helper.imageUrlSelected = this.helper.ifvalnull(this.api.url + data.src,this.api.url + '/uploads/no_img.jpg');
      this.helper.presentSwalCustomContent(options,(value) => {
        let params = {
          productivity_last : data.Productivity.replace("%",""),
          productivity : document.getElementById("input-productivity")['value'],
          notes        : document.getElementById("notes-change-productivity")['value'],
          date         : data.tgl,
          employee_id  : me.parameter.id,
          employee_code: me.parameter.user_code,
          updated_by   : me.userApi.data.Employee_ID,
          file_name    : this.helper.imageNameSelected,
          binary_image : this.helper.imageSelected,
        };
        me.loading = me.helper.showLoading('Process...');
        me.presensiProvider.changeProductivity(params).subscribe((resp ?: any) => {
          try {
            me.loading.dismiss();
          } catch (error) {
            
          }
          if (resp.success) {
            me.getAttendance();
            me.events.publish('presensi:reload');
          }
        });
      }); 
    }
    else if (!akses['edit_presentase_presensi'] && data.flag == 'updated') {
      let element_content = this.generate_element('employee',data,generated_class_label,generated_class_button); 
      let options = {
        buttonConfirm : false,
        title         : "Detail",
        content       : element_content,
        eventListenerContent : true,
        cmpListeners : "progress-presensi",
        generated_class_btn : generated_class_button,
        generated_class_label : generated_class_label
      };
      this.helper.imageUrlSelected = this.helper.ifvalnull(this.api.url + data.src,this.api.url + '/uploads/no_img.jpg');
      this.helper.presentSwalCustomContent(options,(value) => {
        
      }); 
      // this.photoViewer.show(this.api.url + data.src);
    }
  }
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }

  generate_element(state,data,generated_class_label,generated_class_button){
    let element = `
        <div class="background-biru-muda" style="width:100%;padding: 1px 10px;" >
          <p class="text-abu">`+ data.string_date+`<p >
          <div style="display: inline-grid;grid-template-columns:50% 50%;width:100%;">
              <div>
                <p class="text-abu" style="margin:0px;font-size:12px;">In</p>
                <div class="swal-title" style="padding:0px !important;">
                  `+this.helper.ifvalnull(data.TimeIn,'').substring(0,5)+`
                </div>
              </div>
              <div>
                <p class="text-abu" style="margin:0px;font-size:12px;">Out</p>
                <div class="swal-title" style="padding:0px !important;">
                  `+this.helper.ifvalnull(data.TimeOut,'').substring(0,5)+`
                </div>
              </div>
          </div> 
          <p class="text-abu" style="font-size:12px;">
            Min Late <span style="color:black"> `+this.helper.ifvalnull(data.MinLate,'')+` </span>
          </p>
        </div> 
        `;
        if (state=='employee') {
          element += `
          <div style="width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
            <div>
                <span style="font-size: 13px;"> Attachment </span>
                <p class="text-biru `+generated_class_label+`" style="margin: 0px;font-size: 12px;"> `+this.helper.ifvalnull(data.file_name,'')+`</p>
            </div>
          </div>
          <div style="width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
            <div>
                <p style="font-size: 13px;"> Productivity : <span class="text-abu">`+this.helper.ifvalnull(data.Productivity,'0').replace("%","")+`% </span></p> 
            </div>
            <div>
                <p style="font-size: 13px;"> Notes : <span class="text-abu">`+this.helper.ifvalnull(data.notes,'')+`</span></p> 
            </div>
          </div>
          <button class="swal-button swal-button--confirm close-sweetalert-`+generated_class_button+`">Ok</button>`;
        }else{
          element += `
          <div style="display:inline-grid;grid-template-columns: calc(100% - 50px) 50px;width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
            <div>
                <span style="font-size: 13px;"> Attachment </span>
                <p class="text-biru `+generated_class_label+`" style="margin: 0px;font-size: 12px;"> `+this.helper.ifvalnull(data.file_name,'')+`</p>
            </div>
            <div style="text-align: right;">
                <button class="btn-camera  item-button button button-ios button-default button-default-ios" style="background: #b5b9bc !important;font-size: 20px !important;padding: 0px !important;height: 30px !important;width: 40px;"><span
                        class="button-inner">
                        <ion-icon name="custom-camera" role="img" class="`+generated_class_button+` btn-capture-img icon icon-ios ion-ios-custom-camera"
                            aria-label="custom camera" ng-reflect-name="custom-camera"></ion-icon>
                    </span>
                    <div class="button-effect"></div>
                </button> 
            </div>
          </div>
          <div style="padding-top:10px">
            <label class="text-abu" style="padding-right:10px">Productivity</label>
            <input style="width: 40px;-webkit-appearance: none;background-color: #ebebeb;font-size: 14px;box-sizing: border-box;border: 1px solid rgba(0,0,0,.14);border-radius: 2px;transition: border-color .2s;
            padding: 5px !important;" max="3" type="number" name="productivity" id="input-productivity" value="`+
            this.helper.ifvalnull(data.Productivity,'0').replace("%","")+`"> <span class="text-abu">%</span>
          </div>
          <textarea class="swal-content__textarea" rows="7" id="notes-change-productivity" placeholder="Enter Notes Here.." style="margin: 10px;width: calc(100% - 20px);">`+this.helper.ifvalnull(data.notes,'')+`</textarea>
          `;
        }
        return element;
  }

  detailDate(presensi){
    this.helper.imageSelected = null;
    let me = this;
    let generated_class_button = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    let generated_class_label = Math.random().toString(36).substring(1, 15) + Math.random().toString(36).substring(1, 15);
    let element_content = `
    <div class="background-biru-muda" style="width:100%;padding: 1px 10px;" >
      <p class="text-abu">`+ presensi.string_date+`<p >
    </div>
    <div style="text-align:left"> 
      <div style="display:inline-grid;grid-template-columns: auto 60px;text-align: left;padding-top: 25px;padding-left: 10px;padding-bottom: 5px;">
        <p style="margin:0px;margin-right:10px;font-size:15px;">Collective Leave</p>
        <label class="switch">
          <input type="checkbox" id="collective-leave-`+generated_class_label+`">
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <p class="text-abu" style="margin-bottom: 0px;text-align: left;padding-left: 10px;">Description</p>
    <div style="padding:10px">
      <textarea class="swal-content__textarea" rows="7" id="description-collective-leave" placeholder="Enter Description Here..">`+this.helper.ifvalnull(presensi.description,'')+`</textarea>
    </div>
    `;
    let options = {
      buttonConfirm : "Save",
      title         : "Detail",
      content       : element_content,
      eventListenerContent : true,
      cmpListeners : "progress-presensi",
      generated_class_btn : generated_class_button,
      generated_class_label : generated_class_label
    };
    this.helper.presentSwalCustomContent(options,(value) => {
      let params = {
        collective_leave : document.getElementById(`collective-leave-`+generated_class_label)['checked'],
        date         : presensi.tgl,
        employee_id  : me.parameter.id,
        employee_code: me.parameter.user_code,
        updated_by   : me.userApi.data.Employee_ID,
      };
      me.loading = me.helper.showLoading('Process...');
      me.presensiProvider.addCollectiveLeave(params).subscribe((resp ?: any) => {
        try {
          me.loading.dismiss();
        } catch (error) {
          
        }
        if (resp.success) {
          me.getAttendance();
          me.events.publish('presensi:reload');
        }
      });
    }); 
  }
}



// WEBPACK FOOTER //
// ./src/pages/presensi/attendance/page.ts